import React from 'react';
import { UserEntitlementsProps } from 'Modules/AnytimeTicket/Components/UserEntitlements/UserEntitlementsUtils';
import UserEntitlementCard from 'Modules/AnytimeTicket/Components/UserEntitlements/UserEntitlementCard';
import { anytimeTicketsInline } from 'Util/_HumanWritten/anytimeTicketTerm';

export default function UserEntitlementsList({ reload, userEntitlements }: UserEntitlementsProps) {
	return (
		<div
			className={`gift-voucher-list__container ${(userEntitlements?.count ?? 0) > 4 ? 'pagination-applied' : ''}`}
		>
			{userEntitlementsInner(reload, userEntitlements?.userEntitlements)}
		</div>
	);
}

function userEntitlementsInner(refresh: () => void, entitlements?: any[]) {
	if (!entitlements) {
		return <></>;
	}

	if (entitlements.length > 0) {
		return entitlements.map(entitlement => (
			<UserEntitlementCard key={entitlement.id} entitlement={entitlement} refresh={refresh} />
		));
	}

	return (
		<div className="no-vouchers__container">
			<p>No {anytimeTicketsInline()} to display</p>
		</div>
	);
}
